<body>
  <br />
  <h1>Patent Chest&reg;</h1>
  <br />
  <div class="row">
    <div class="col-xs-12">
      <div *ngIf="isLoading">
        <app-loading-spinner></app-loading-spinner>
      </div>
      <div class="alert alert-danger" *ngIf="error">{{ error }}</div>
      <form
        #authForm="ngForm"
        (ngSubmit)="onSubmit(authForm)"
        *ngIf="!isLoading"
      >
        <div class="form-group">
          <label for="email">E-posta adresi</label>
          <input
            type="email"
            id="email"
            class="form-control"
            (input)="onMailChange($event)"
            [(ngModel)]="email"
            name="email"
            minlength="6"
          />
        </div>
        <div class="form-group">
          <label for="password">Şifre</label>
          <input
            type="password"
            id="password"
            class="form-control"
            (input)="onPasswordChange($event)"
            [(ngModel)]="password"
            name="password"
            minlength="6"
          />
        </div>
        <a
          href="https://firebasestorage.googleapis.com/v0/b/patent-book.appspot.com/o/Patent%20Chest%20Kullan%C4%B1m%20K%C4%B1lavuzu.pdf?alt=media&token=53a35b46-222b-4a7e-af8a-20667247724d"
          target="_blank"
        >
          <br />
          <h1 style="margin-left: 1%">Kullanım Kılavuzu</h1>
        </a>
        <br />
        <div>
          <!-- <button class="btn btn-primary" type="submit" [disabled]="!authForm.valid">{{isLogged ? 'Login':'SignUp'}}</button>
            <button class="btn btn-danger" (click)="onSwitchMode()" type="button">{{isLogged ? 'Switch to signUp':'Switch to Login'}}</button> -->

          <button
            class="btn btn-primary"
            type="submit"
            [disabled]="isFormValid || isMailValid"
            style="margin-right: 125px"
            style="background-color: #28384f"
          >
            Giriş
          </button>

          <button
            type="button"
            style="margin-right: 0"
            class="btn btn-warning"
            [disabled]="isMailValid"
            (click)="changePassword(authForm)"
            style="background-color: #d70040"
          >
            Şifre Değiştir</button
          ><span style="font-size: 18px"
            >(Şifre değişikliği için e-posta adresinizi giriniz)</span
          >
          <p></p>
        </div>
      </form>
      <br />
      <h1>
        Deneme kullanımı için
        <span style="color: #d70040">patentchest@gmail.com</span>
        adresine e-posta gönderebilirsiniz
      </h1>
    </div>
  </div>
</body>
